var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentWindowDevEdit20Regular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 53,
    viewBox: "0 0 64 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:window-dev-edit-20-regular",
    filter: "url(#filter0_d_619_1752)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.734375,
    width: 60,
    height: 48,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0026 8.73438C16.6758 8.73438 15.4034 9.26115 14.4652 10.1988C13.5271 11.1365 13 12.4082 13 13.7343V31.7338C13 33.0599 13.5271 34.3316 14.4652 35.2693C15.4034 36.2069 16.6758 36.7337 18.0026 36.7337H27.9577C28.1778 36.0117 28.524 35.3337 28.9782 34.7337H18.0026C17.2065 34.7337 16.4431 34.4177 15.8802 33.8551C15.3173 33.2925 15.001 32.5294 15.001 31.7338V16.7322H39.0134V24.62L39.2175 24.416C39.7498 23.882 40.3621 23.476 41.0144 23.196V13.7343C41.0144 12.4082 40.4873 11.1365 39.5492 10.1988C38.611 9.26115 37.3386 8.73438 36.0118 8.73438H18.0026ZM14.999 13.7323C14.999 12.9366 15.3153 12.1736 15.8782 11.611C16.4411 11.0484 17.2045 10.7323 18.0006 10.7323H36.0098C36.8059 10.7323 37.5693 11.0484 38.1322 11.611C38.6951 12.1736 39.0114 12.9366 39.0114 13.7323V14.7322H14.999V13.7323ZM25.7105 19.0241C25.8981 19.2116 26.0035 19.466 26.0035 19.7311C26.0035 19.9963 25.8981 20.2506 25.7105 20.4381L21.4163 24.734L25.7105 29.0259C25.8928 29.2145 25.9936 29.4671 25.9914 29.7293C25.9891 29.9915 25.8839 30.2423 25.6983 30.4277C25.5128 30.6131 25.2619 30.7182 24.9996 30.7205C24.7372 30.7228 24.4845 30.622 24.2958 30.4398L19.2932 25.44C19.1057 25.2524 19.0003 24.9981 19.0003 24.733C19.0003 24.4678 19.1057 24.2135 19.2932 24.026L24.2958 19.0261C24.4834 18.8387 24.7379 18.7333 25.0032 18.7333C25.2685 18.7333 25.5229 18.8367 25.7105 19.0241ZM29.3004 29.0239C29.1128 29.2117 29.0075 29.4662 29.0077 29.7316C29.0079 29.9969 29.1135 30.2513 29.3014 30.4388C29.4893 30.6264 29.744 30.7316 30.0095 30.7314C30.275 30.7312 30.5295 30.6256 30.7171 30.4378L35.7197 25.438C35.9072 25.2504 36.0126 24.9961 36.0126 24.731C36.0126 24.4658 35.9072 24.2115 35.7197 24.024L30.7171 19.0241C30.5295 18.8364 30.275 18.7308 30.0095 18.7306C29.744 18.7304 29.4893 18.8356 29.3014 19.0231C29.1135 19.2106 29.0079 19.465 29.0077 19.7304C29.0075 19.9958 29.1128 20.2503 29.3004 20.4381L33.5966 24.734L29.3004 29.0239ZM40.6322 25.83L30.9672 35.4897C30.4047 36.0527 30.0056 36.7578 29.8126 37.5297L29.0623 40.5256C28.9883 40.8236 28.9926 41.1356 29.0749 41.4314C29.1572 41.7272 29.3147 41.9966 29.532 42.2136C29.7493 42.4306 30.0191 42.5877 30.3151 42.6697C30.6111 42.7517 30.9233 42.7558 31.2214 42.6816L34.2189 41.9336C34.9916 41.7404 35.6971 41.3408 36.26 40.7776L45.9249 31.1178C46.6176 30.4145 47.004 29.4661 47 28.4792C46.996 27.4923 46.6018 26.5471 45.9035 25.8494C45.2052 25.1517 44.2593 24.7581 43.2719 24.7545C42.2845 24.7509 41.3357 25.1374 40.6322 25.83Z",
    fill: "#7750BF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.23438,
    width: 59,
    height: 47,
    rx: 11.5,
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_619_1752",
    x: 0,
    y: 0.734375,
    width: 64,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_619_1752"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_619_1752",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentWindowDevEdit20Regular);
export default __webpack_public_path__ + "static/media/fluent_window-dev-edit-20-regular.94a5f715e4872088779731d3e35d2d3d.svg";
export { ForwardRef as ReactComponent };